import { httpV2 } from "@/api";

const Qs = require("qs");

/**
 * Requisição da lista sinais de tendências.
 * @param {Object} parameters Objeto de parâmetros passados por query e path na requisição.
 * @returns Lista de sinais.
 */
const GetSignalsList = function(parameters)
{
	const params = {};
	params.component = parameters.component;

	return httpV2.get(`/HydroVDI/${parameters.monitoringElementId}/AvailableTrendSignals`,
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Requisição do pior caso de IDV.
 * @param {Object} parameters Objeto de parâmetros passados por query e path na requisição.
 * @returns Sinal com pior IDV.
 */
const GetWorstVDI = function(parameters)
{
	const params = {};
	params.component = parameters.component;

	return httpV2.get(`/HydroVDI/${parameters.monitoringElementId}/WorstVDIRegion`,
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Requisição da lista dos ultimos IDV's calculados para todas as UG's.
 * @param {Object} parameters Objeto com a lista de monitoring Element Id's.
 * @returns Array de objetos com os indicadores de vibração.
 */
const GetVDIGeneratingUnits = function(parameters)
{
	const params = {};
	params.monitoringElementIds = parameters;

	return httpV2.get("/HydroVDI/GeneratingUnitsLastValue",
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Requisição de dados do gráfico de tendências.
 * @param {Object} parameters Objeto de parâmetros passados por query na requisição.
 * @returns Dados para construção do gráfico.
 */
const GetTrendChart = function(parameters)
{
	const params = {};
	params.trendSignalSettingId = parameters.signalSettingId;
	params.startDateTime = parameters.startDateTime;
	params.endDateTime = parameters.endDateTime;
	params.powerRange = parameters.powerRange;
	params.nettHeadRange = parameters.nettHeadRange;
	return httpV2.get("/HydroVDI/TrendChart",
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

/**
 * Requisição de dados do gráfico de heatmap.
 * @param {Object} parameters Objeto de parâmetros passados por query na requisição.
 * @returns Dados para construção do gráfico.
 */
const GetHeatmapChart = function(parameters)
{
	const params = {};
	params.trendSignalSettingId = parameters.signalSettingId;
	params.startDateTime = parameters.startDateTime;
	params.endDateTime = parameters.endDateTime;

	return httpV2.get("/HydroVDI/HeatMapChart",
		{
			params:           params,
			paramsSerializer: params => Qs.stringify(params, { encode: false }),
		});
};

export default
{
	GetTrendChart,
	GetHeatmapChart,
	GetSignalsList,
	GetVDIGeneratingUnits,
	GetWorstVDI
};